import { NextPage } from 'next'
import { asPage, PageProps } from 'src/components/hoc/asPage'
import { EventDetail } from 'src/compositions/Events/EventDetail'

const EeventDetailPage: NextPage<PageProps<{}, { id: number }>> = ({
  router,
}) => {
  const id = +(router?.query.id || 0)
  // TODO Loading
  if (!id) return <></>

  return <EventDetail id={id} />
}

export default asPage(EeventDetailPage, { pageTitle: 'イベント詳細' })
